module.exports = __webpack_public_path__ + "../resources/images/illustration_task-317a41c69a89213897a96d7b97df2340.svg";